module.exports = __webpack_public_path__ + "05ebfc9b026b53470e34365c21855462.pdf";